export const COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Order",
    Footer: "Order",
    accessor: "redemption_type",
  },
  {
    Header: "Order Code",
    Footer: "Order Code",
    accessor: "ordercode",
  },
  {
    Header: "Order Value",
    Footer: "Order Value",
    accessor: "ordervalue",
  },
  {
    Header: "Title",
    Footer: "Title",
    accessor: "title",
    Cell: ({ value }) => <div className="d-flex flex-wrap gap-1">{value}</div>,
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionDate",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

// Sobisco: same as COLUMNS with Order Status after Order Code
export const SOBISCO_COLUMNS = COLUMNS.flatMap((col) =>
  col.accessor === "ordercode"
    ? [
        col,
        {
          Header: "Order Status",
          Footer: "Order Status",
          accessor: "order_status",
        },
      ]
    : [col],
);
